import { AxiosRequestConfig } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { ApiError } from '@types';
import { config } from '../../config';

export const fetchLIPTileAsync = createAsyncAction(
    [
        'liptile/FETCH_LIP_TILE_REQUEST',
        (loanNumber: any) => {
            return {
                url: `${config.env('selfServUrl')}/${loanNumber}/status-tile`,
                method: 'get',
                headers: {
                    applicationName: 'auth_customer_portal',
                    'x-api-key': `${config.env('xApiKey')}`
                }
            } as AxiosRequestConfig;
        }
    ],
    ['liptile/FETCH_LIP_TILE_SUCCESS', (response: any) => response],
    ['liptile/FETCH_LIP_TILE_FAILURE', (error: ApiError) => error],
    'liptile/FETCH_LIP_TILE_CANCEL'
)();
